import React from 'react';
import { Drawer} from '@material-ui/core';
import {BUTTON, Button} from 'components/common/Button/Button';
import styles from './DismissibleModal.scss';


export default function DismissibleModal(props) {
    const {
        title,
        open,
        onDismiss,
        children,
        onSubmit,
        submitActionDisabled,
        submitTitle
    } = props;

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onDismiss}
            hideBackdrop
            disableEscapeKeyDown
            classes={{
                root: styles.DPanel,
            }}
            data-cy="DismissibleModal"
        >
            <div className={styles.DContainer}>
                <Header title={title} onClosePanel={onDismiss} data-cy="DismissibleModal-onClosePanel"/>
                <div data-cy="DismissibleModal-children">
                    {children}
                </div>
                <Footer
                    onSubmit={onSubmit}
                    onClosePanel={onDismiss}
                    unableToSubmit={submitActionDisabled}
                    submitTitle={submitTitle}
                    data-cy="DismissibleModal-onSubmit"
                />
            </div>
        </Drawer>
    );
}

function Header({ title, onClosePanel }) {
    return (
        <div className={styles.DContainer__Header} data-cy="DismissibleModal-Header">
            <h5 data-cy="DismissibleModal-Headertitle">{title}</h5>
            <i className={styles.CloseIcon} onClick={onClosePanel} data-cy="DismissibleModal-onClick">
                close
            </i>
        </div>
    );
}

export function Footer({ onClosePanel, onSubmit, unableToSubmit, submitTitle }) {
    return (
        <div className={styles.DContainer__Footer} data-cy="DismissibleModal-Footer">
            <Button
                bgcolor={BUTTON.BGCOLOR.CLEAR}
                color={BUTTON.COLOR.BLACK}
                outline={BUTTON.OUTCOLOR.LIGHTGREY}
                onClick={onClosePanel}
                data-cy="DismissibleModal-Cancel"
            >
                Cancel
            </Button>
            <Button
                bgcolor={BUTTON.BGCOLOR.ORANGE}
                color={BUTTON.COLOR.WHITE}
                onClick={onSubmit}
                disabled={unableToSubmit}
                data-cy="DismissibleModal-submitTitle"
            >
                {submitTitle}
            </Button>
        </div>
    );
}
